<header>
  <nav
    class="navbar fixed-top navbar-expand-lg navbar-light bg-white py-0 shadow-sm navbar-fixed"
  >
    <div class="modo">
      {{ modo }}
    </div>
    <div class="container">
      <a class="navbar-brand" href="/">
        <img
          src="../assets/img/logoSlogan.svg"
          class="img-nav img-fluid my-2"
          alt="Meu Vidraceiro"
        />
      </a>
      <button
        class="navbar-toggler mr-3"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="nav navbar-nav w-100 justify-content-end">
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" [routerLink]="['/']"
              >Home <span class="sr-only">(current)</span></a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" [routerLink]="['/quem-somos']"
              >Quem Somos</a
            >
          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" [routerLink]="['/aplicativo']">Aplicativo</a> -->
            <a
              class="nav-link"
              data-toggle="tab"
              [routerLink]="['/aplicativo-para-vidracarias-e-serralherias']"
              >Aplicativo</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" [routerLink]="['/blog']"
              >Blog</a
            >
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link " data-toggle="tab" [routerLink]="['/cursos']">Cursos</a>
          </li> -->
        </ul>
      </div>
    </div>
  </nav>
</header>
<router-outlet></router-outlet>

<footer class="p-0">
  <div class="container">
    <div class="row py-5">
      <div class="col-md-3 col-12 footer-column order-1 order-md-0">
        <ul class="nav">
          <li class="nav-item mt-3">
            <!--a href="#">
              <img src="img/logoBranco.png" alt="" height="25">
            </a-->
          </li>
          <li class="nav-item mt-4">
            <a class="nav-link" href="#">
              <img
                src="https://meuvidraceiro.com.br/images/logo-vi.png"
                alt=""
              />
            </a>
          </li>
          <li class="d-flex mt-4">
            <div class="d-flex w-100 justify-content-center">
              <a
                class="icon-button instagram"
                target="_blank"
                href="https://www.instagram.com/meu_vidraceiro/ "
              >
                <i class="fab fa-instagram icon-instagram"></i><span></span>
              </a>
              <a
                class="icon-button facebook"
                target="_blank"
                href="https://www.facebook.com/MeuVidraceiro-381071825721679/"
              >
                <i class="icon-facebook fab fa-facebook-f"> </i><span></span
              ></a>
              <a
                target="_blank"
                href="https://www.youtube.com/channel/UC3PrQFT5S9j1yer4L2bZyzQ"
                class="icon-button youtube"
                ><i class="icon-youtube fab fa-youtube"></i><span></span
              ></a>
            </div>
          </li>
        </ul>
      </div>

      <div class="col-md-6 footer-column order-0 order-md-1 mb-3 mt-3">
        <ul
          class="nav flex-column w-100"
          *ngIf="router.url != '/aplicativo-para-vidracarias-e-serralherias'"
        >
          <div class="row">
            <div class="col-12 col-md-6 mb-2">
              <p class="mb-0 text-white letra-footer font-weight-bold">
                Quer sua vidraçaria
              </p>
              <p class="text-white mb-0 letra-footer font-weight-bold">
                divulgada
              </p>

              <p class="mb-0 text-white letra-footer font-weight-bold">
                para todo o Brasil?
              </p>
            </div>

            <div class="col-12 col-md-6 my-auto mb-2">
              <button
                class="btn btn-white bg-white pulse text-muted w-100 p-1 rounded-pill"
                (click)="toTop()"
                [routerLink]="['/aplicativo-para-vidracarias-e-serralherias']"
              >
                <p class="mb-2">Conheça o aplicativo</p>
                <img
                  src="assets/img/logo.svg"
                  class="img-fluid img-footer mb-2"
                  alt=""
                />
              </button>
            </div>
            <div class="col-12 mt-0">
              <hr class="bg-warning mt-1" />
            </div>
          </div>

          <!-- <li class="nav-item mt-4">
            <a class="btn btn-laranja w-100  rounded-pill pr-4 pl-4 p-1 "
              href="https://meuvidraceiro.com.br/souvidraceiro/" (click)="toTop()">Conhecer Aplicativo</a>
          </li> -->

          <!--li class="nav-item mt-4">
            <button class="btn btn-white text-btn pr-4 pl-4 p-2 ">Sou Contratante</button>
          </!--li-->
        </ul>
      </div>

      <div class="col-md-3 footer-column order-2 order-md-2">
        <ul class="nav flex-column mt-4 text-right">
          <li class="nav-item">
            <a
              class="nav-link small"
              [routerLink]="['/quem-somos']"
              (click)="toTop()"
              >Quem Somos</a
            >
          </li>
          <!--li class="nav-item">
            <a class="nav-link" href="#">Dicas e Tutoriais</a>
          </!--li-->
          <!--li class="nav-item">
            <a class="nav-link" href="#">Termos de Uso</a>
          </!--li-->
          <li class="nav-item">
            <a class="nav-link small" [routerLink]="['/blog']" (click)="toTop()"
              >Blog para Contratantes</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link small" [routerLink]="['/blog']" (click)="toTop()"
              >Blog para Vidraceiros</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="row text-center mt-4 mb-0 mx-auto p-2 corBlueDark">
    <div class="col-12 box">
      <span class="copyright quick-links"
        >Copyright &copy;
        <script>
          document.write(new Date().getFullYear());
        </script>
        Meu Vidraceiro 2021, Serviços de Internet. CNPJ 40.157.469/0001-53
      </span>
    </div>
  </div>
</footer>
